var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "#727981",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.25C1.5 13.075 2.175 13.75 3 13.75H9C9.825 13.75 10.5 13.075 10.5 12.25V3.25H1.5V12.25ZM3.8775 7.4425C3.585 7.15 3.585 6.6775 3.8775 6.385C4.17 6.0925 4.6425 6.0925 4.935 6.385L6 7.4425L7.0575 6.385C7.35 6.0925 7.8225 6.0925 8.115 6.385C8.4075 6.6775 8.4075 7.15 8.115 7.4425L7.0575 8.5L8.115 9.5575C8.4075 9.85 8.4075 10.3225 8.115 10.615C7.8225 10.9075 7.35 10.9075 7.0575 10.615L6 9.5575L4.9425 10.615C4.65 10.9075 4.1775 10.9075 3.885 10.615C3.5925 10.3225 3.5925 9.85 3.885 9.5575L4.9425 8.5L3.8775 7.4425ZM10.5 1H8.625L8.0925 0.4675C7.9575 0.3325 7.7625 0.25 7.5675 0.25H4.4325C4.2375 0.25 4.0425 0.3325 3.9075 0.4675L3.375 1H1.5C1.0875 1 0.75 1.3375 0.75 1.75C0.75 2.1625 1.0875 2.5 1.5 2.5H10.5C10.9125 2.5 11.25 2.1625 11.25 1.75C11.25 1.3375 10.9125 1 10.5 1Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.f8dfb2d7.svg";
export { ForwardRef as ReactComponent };